import { Button } from '../../../button';
import { Dropdown } from '../../../dropdown';
import { Icon } from '../../../icons';
import type { MenuItemType } from '../../../menu';

export type MessagesSidebarItemActions = {
  className?: string;
  items?: MenuItemType[];
};

const Actions = ({ className, items }: MessagesSidebarItemActions) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <Dropdown
      menu={{
        items,
      }}
      placement="bottomRight"
      trigger={['click']}
    >
      <Button
        className={className}
        icon={<Icon icon="more-2-line" />}
        onClick={(event) => {
          event.stopPropagation();
        }}
        size="small"
        type="link-primary"
      />
    </Dropdown>
  );
};

export default Actions;
